import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-column flex-grow-1" }
const _hoisted_2 = { class: "flex justify-content-between" }
const _hoisted_3 = { class: "flex align-items-center" }
const _hoisted_4 = {
  key: 0,
  class: "ml-auto white-space-nowrap"
}
const _hoisted_5 = { class: "caption mt-s2" }

import Spinner from '@/components/Spinner.vue';
import TokenIcon from '@/components/token/TokenIcon.vue';
import { Token } from '@/sdk/entities/token';
import { format } from '@/utils/format';
import { computed } from 'vue';
import { ENABLE_CROSS_CHAIN } from '@/helpers/crossChainEnv.helper';
import { DEFAULT_NETWORK_ID } from '@/helpers/networkParams.helper';
import { useEVMWallet } from '@/store/modules/wallet/useEVMWallet';
import { useBalances } from '@/store/modules/tokens/useBalances';
import { useTokens } from '@/store/modules/tokens/useTokens';
import TokenNoBridgeLabel from '@/components/tokenSelect/TokenNoBridgeLabel.vue';
import { ENABLE_FAKE_CARDANO_NETWORK } from '@/helpers/fakeCardanoNetwork';
import { DEFAULT_CARDANO_CHAIN_ID } from '@/constants/DEFAULT_CARDANO_ID';


export default /*#__PURE__*/_defineComponent({
  __name: 'TokenPanel',
  props: {
    token: null,
    isBaseToken: { type: Boolean },
    hideZeroBalance: { type: Boolean }
  },
  emits: ["click"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'click'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  token: Token;
  isBaseToken?: boolean;
  hideZeroBalance?: boolean;
}





const { isPresentTokenIntoNetwork } = useTokens();
const { walletState } = useEVMWallet();
const { balanceByToken } = useBalances();

const tokenBalance = balanceByToken(props.token);
const isShowTokenPanel = computed(
  () => !(props.hideZeroBalance && !tokenBalance.value?.balance?.greaterThan('0')),
);
const isHideBalance = computed(
  () =>
    (ENABLE_CROSS_CHAIN &&
      +props.token.chainId !== (walletState.network?.chainId ?? DEFAULT_NETWORK_ID)) ||
    !tokenBalance.value ||
    tokenBalance.value?.status === 'failed',
);
const isTokenNoBridge = computed(() => {
  if (!ENABLE_FAKE_CARDANO_NETWORK) return false;

  return (
    +props.token.chainId === +DEFAULT_NETWORK_ID! &&
    !isPresentTokenIntoNetwork(props.token.symbol!, +DEFAULT_CARDANO_CHAIN_ID)
  );
});
const onClick = () => {
  emits('click');
};

return (_ctx: any,_cache: any) => {
  return (_unref(isShowTokenPanel))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["flex-shrink-0 w-full text-left token-panel justify-content-start clickable ord", __props.isBaseToken ? 'flex-order-0' : 'flex-order-1']),
        onClick: onClick
      }, [
        (__props.token)
          ? (_openBlock(), _createBlock(TokenIcon, {
              key: 0,
              "icon-src": __props.token.tokenIconUrl,
              symbol: __props.token.symbol,
              class: "mr-s3",
              "chain-id": __props.token.chainId
            }, null, 8, ["icon-src", "symbol", "chain-id"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", null, _toDisplayString(__props.token.symbol), 1),
              (_unref(isTokenNoBridge))
                ? (_openBlock(), _createBlock(TokenNoBridgeLabel, {
                    key: 0,
                    class: "ml-s2"
                  }))
                : _createCommentVNode("", true)
            ]),
            (_unref(walletState).isInjected && !_unref(isHideBalance))
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_unref(tokenBalance)?.status === 'not-fetched')
                    ? (_openBlock(), _createBlock(Spinner, {
                        key: 0,
                        color: "white"
                      }))
                    : (_unref(tokenBalance)?.status === 'success')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(_unref(format)(_unref(tokenBalance).balance.toFixed())), 1)
                        ], 64))
                      : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_5, _toDisplayString(__props.token.name), 1)
        ])
      ], 2))
    : _createCommentVNode("", true)
}
}

})